import { APIRoute } from '@/modules/utils'

export const Route: APIRoute = {
  method: 'POST',
  path: '/v2/identity/certify',
}

export type Body = {
  recto?: string
  verso?: string
}

export type Response = { isCertificationAccepted: boolean }
